'use strict';

module.exports = require('./hyphenated-de.cjs.js');